import React, { createContext, useContext, useMemo } from 'react';
import { getAllRestrictedDates } from '@ally/data-selectors-restricted-dates';
import { getHolidays } from './utils';
export var HolidaysContext = createContext({
    federal: {},
    nyse: {},
    taxDay: {},
});
export var HolidaysProvider = function (_a) {
    var hostData = _a.hostServices.hostData, children = _a.children;
    var holidays = useMemo(function () {
        var _a;
        var restrictedDates = (_a = getAllRestrictedDates(hostData)) !== null && _a !== void 0 ? _a : [];
        return getHolidays(restrictedDates);
    }, [hostData.restrictedDates]);
    return (React.createElement(HolidaysContext.Provider, { value: holidays }, children));
};
export var useHolidays = function () { return useContext(HolidaysContext); };
//# sourceMappingURL=useHolidays.js.map